module.exports = __webpack_public_path__ + "img/insurance.d58fe733.png";